export default __webpack_public_path__ + "static/media/Arrow_down.8539da07.svg";